<mat-card class="chart-image-card">
  <div
    #chartViewport
    [class]="viewportClass"
    (pointerdown)="handlePointerDown($event)"
    (pointermove)="handlePointerMove($event)"
    (pointerup)="handlePointerUp($event)"
    (pointercancel)="handlePointerCancel($event)">
    <div class="chart-image-surface">
      <div
        class="chart-image-stage"
        [style.transform]="stageTransform"
        [style.width.px]="imageNaturalWidth || null"
        [style.height.px]="imageNaturalHeight || null">
        <img
          *ngIf="imageSource"
          class="chart-image"
          alt="Patient Chart"
          [src]="imageSource"
          draggable="false"
          (load)="handleImageLoad($event)"
          [style.width.px]="imageNaturalWidth || null"
          [style.height.px]="imageNaturalHeight || null" />
      </div>
    </div>
  </div>
</mat-card>
